// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"e5a20be9","43":"cadfa029","119":"67763416","950":"c6b570ac"}[chunkId] + ".chunk.js";
};